export const importResponseTemplate = data => {
  if (!data || data.total === undefined) {
    return 'Import thành công!';
  }
  return `
      <span class="row">
   <p class="font-weight-800 col-6">Tổng data import:</p> <p class="font-weight-500 col-6 text-comment">${data.total}</p>
          <p class="font-weight-800 col-6">Import thành công:</p> <p class="font-weight-500 col-6 text-success">${data.success}</p>
          <p class="font-weight-800 col-6">Import không thành công:</p> <p class="font-weight-500 col-6 text-danger">${data.failure}</p>
      </span>`;
};



// WEBPACK FOOTER //
// ./src/app/common/conversations/import.response.ts